import { render, staticRenderFns } from "./cModalAddStockInitial.vue?vue&type=template&id=51f33808"
import script from "./cModalAddStockInitial.vue?vue&type=script&lang=js"
export * from "./cModalAddStockInitial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports